import React from "react";
import { useTranslation } from "react-i18next";

export default function VirtualSummaryCards({ data }) {
    const { t, i18n } = useTranslation();

    const items = [
        { key: "P_IMPORT", label: t('energies.activeImport'), unit: "kWh", color: "bg-green-600" },
        { key: "P_EXPORT", label: t('energies.activeExport'), unit: "kWh", color: "bg-amber-600" },
        { key: "Q_IMPORT", label: t('energies.reactiveImport'), unit: "kVArh", color: "bg-blue-600" },
        { key: "Q_EXPORT", label: t('energies.reactiveExport'), unit: "kVArh", color: "bg-red-600" },
    ];


    return (
        <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
            {items.map((item) => (
                <div
                    key={item.key}
                    className="bg-white border p-4 rounded-xl shadow-sm flex flex-col justify-between"
                >
                    <span className="text-sm text-slate-500">{item.label}</span>

                    <div className="mt-2 flex items-end gap-1">
                        <span className="text-2xl font-semibold">
                            {Number(data[item.key] || 0).toFixed(3)}
                        </span>
                        <span className="text-sm">{item.unit}</span>
                    </div>

                    <div className={`w-full h-1 mt-3 rounded ${item.color}`}></div>
                </div>
            ))}
        </div>
    );
}
